export const LEANING_OPTIONS = Object.freeze([
  Object.freeze({ id: 'masculine', label: 'Masculine', position: -1 }),
  Object.freeze({ id: 'unisex', label: 'Unisex', position: 0 }),
  Object.freeze({ id: 'feminine', label: 'Feminine', position: 1 }),
])

const aliases = new Map([
  ['male', 'masculine'], ['men', 'masculine'], ['man', 'masculine'], ['masculine', 'masculine'],
  ['female', 'feminine'], ['women', 'feminine'], ['woman', 'feminine'], ['feminine', 'feminine'],
  ['unisex', 'unisex'], ['shared', 'unisex'], ['genderless', 'unisex'],
])

export function normalizeLeaning(value) {
  const normalized = String(value || '').trim().toLocaleLowerCase()
  if (!normalized) return ''
  if (aliases.has(normalized)) return aliases.get(normalized)
  if (/\b(men|male|masculine)\b/u.test(normalized)) return 'masculine'
  if (/\b(women|female|feminine)\b/u.test(normalized)) return 'feminine'
  if (/\b(unisex|shared|genderless)\b/u.test(normalized)) return 'unisex'
  return ''
}

// The catalog's existing gender label is the source of this per-fragrance
// attribute. `leaning` is accepted first so a future additive source can use
// the same consumer without changing filter or ranking semantics.
export function fragranceLeaning(fragrance) {
  return normalizeLeaning(fragrance?.leaning || fragrance?.gender_class || fragrance?.gender)
}

export function leaningPosition(fragrance) {
  const leaning = fragranceLeaning(fragrance)
  return LEANING_OPTIONS.find(option => option.id === leaning)?.position ?? null
}

// A shelf preference ranks every bottle; it never excludes an identity.
export function leaningDistance(fragrance, target) {
  if (!Number.isFinite(target)) return 0
  const position = leaningPosition(fragrance)
  return position == null ? 3 : Math.abs(position - target)
}
